import * as React from 'react';
import MainButton from "@/components/buttons/MainButton";

const PriceCardWrapper: React.FC<{
  children: React.ReactNode;
  highlight?: boolean;
  /** CTA BUTTON */
  cta: string;
  href: string;
}> = ({
  children,
  highlight,
  cta,
  href
}) => {
  return (
    <div className={
      `
        p-8
        w-full md:w-[350px] h-auto
        flex flex-col gap-5 rounded-xl
        rounded-[20px]
        ${highlight ? 'bg-slate-100' : 'bg-white'}
        ${highlight ? 'border-2 border-slate-300' : 'border border-slate-100'}
      `}>
      {children}
      <MainButton className="w-full h-14 mt-auto" href={href}>
        {cta}
      </MainButton>
    </div>
  );
};

export default PriceCardWrapper;
